/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Journal_RefreshInputs */



/**
* | output |
* | --- |
* | "Refresh every" |
*
* @param {Alarms_Journal_RefreshInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_journal_refresh = /** @type {((inputs?: Alarms_Journal_RefreshInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Journal_RefreshInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Refresh every")
	return /** @type {LocalizedString} */ ("Actualiser toutes les")
});